export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/companies/state.js